import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../contexts/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import NavDropdown from './NavDropdown';

const TOOL_ROUTES = ['/generator-timova', '/raspored-turnira', '/semafor-online'];
const TOOL_ICONS = ['🎲', '📅', '⏱️'];
const GAME_ROUTES = ['/penalty-shootout', '/koji-si-igrac', '/nogomandala'];
const GAME_ICONS = ['🥅', '⚽', '🎯'];

const buildMenu = (items, routes, icons) =>
  items.map(([label, description], index) => ({
    to: routes[index],
    icon: icons[index],
    label,
    description,
  }));

const PublicPageNav = ({ className = '' }) => {
  const { t } = useTranslation();
  const toolsMenu = buildMenu(t('landing.toolsMenu'), TOOL_ROUTES, TOOL_ICONS);
  const gamesMenu = buildMenu(t('landing.gamesMenu'), GAME_ROUTES, GAME_ICONS);

  return (
    <header className={`landing-nav ${className}`.trim()}>
      <div className="landing-nav-inner">
        <Link to="/" className="landing-logo" style={{ textDecoration: 'none' }}>
          <span className="landing-logo-mark" role="img" aria-label={t('common.brandBall')}>⚽</span>
          <span className="landing-logo-text">StatArena</span>
        </Link>
        <nav className="landing-nav-links">
          <Link to="/">{t('nav.home')}</Link>
          <NavDropdown label={t('nav.tools')} items={toolsMenu} />
          <NavDropdown label={t('nav.games')} items={gamesMenu} />
          <LanguageSwitcher />
          <Link to="/login" className="landing-nav-login">{t('nav.login')}</Link>
          <Link to="/register" className="btn btn-primary landing-nav-cta">
            {t('nav.registerCta')}
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default PublicPageNav;
